export default __webpack_public_path__ + "static/media/discover.9e1cbe34.svg";